import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BusinessUnitLockedInformationComponent } from './business-unit-locked-information.component';
import { FiAppTextSharedModule } from '@fi-shared/app-text';

@NgModule({
    imports: [CommonModule, FiAppTextSharedModule],
    declarations: [BusinessUnitLockedInformationComponent],
    exports: [BusinessUnitLockedInformationComponent],
})
export class BusinessUnitLockedInformationModule {}
